import Bugsnag from '@bugsnag/js'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { Alert, Box, Button, CircularProgress } from '@mui/material'
import { useState } from 'react'

type SignedBiDownloadButtonProps = {
  onDownload: () => Promise<void>
}

const SignedBiDownloadButton = ({ onDownload }: SignedBiDownloadButtonProps) => {
  const [downloading, setDownloading] = useState(false)
  const [failed, setFailed] = useState(false)

  const handleClick = async () => {
    setDownloading(true)
    setFailed(false)
    try {
      await onDownload()
    } catch (err) {
      Bugsnag.notify(err as Error)
      setFailed(true)
    } finally {
      setDownloading(false)
    }
  }

  return (
    <>
      <Box>
        <Button
          variant="contained"
          disabled={downloading}
          startIcon={downloading ? <CircularProgress size={18} color="inherit" /> : <FileDownloadOutlinedIcon />}
          onClick={() => void handleClick()}
          sx={{ height: { xs: 45 }, width: { xs: '100%', sm: 'auto' } }}
        >
          {downloading ? 'Téléchargement…' : 'Télécharger le document signé'}
        </Button>
      </Box>
      {failed && (
        <Alert severity="error" sx={{ mt: 2 }}>
          Le document n’a pas pu être téléchargé. Veuillez réessayer.
        </Alert>
      )}
    </>
  )
}

export default SignedBiDownloadButton
